import davidAvatar from '@/images/david-bust.webp'
import davidThinking from '@/images/david-thinking.png'
import hannaAvatar from '@/images/hanna-bust.webp'
import clerkConfig from '../../../shared/clerk.json'

type Env = 'development' | 'stage' | 'preview' | 'production'
export type AgentId = 'david' | 'hanna'

// Global build-time variables injected by Bun's define
declare const __APP_VERSION__: string | undefined
declare const __BUILD_ENVIRONMENT__: Env | undefined

// Chameleon account token. Public by design — same class as the Clerk
// publishable keys — and one value for every environment, so it lives here
// instead of the BUN_PUBLIC_* pipeline: that route needs a build.ts `define`
// entry plus a secret in three deploy workflows, and resolves silently to '' in
// any build that misses one.
export const CHAMELEON_ACCOUNT_TOKEN =
  'Sjw9myRwcQWuA5NMBB6Ga7FtX2L0ZHruIcTQgZcMi63i24-1WOJJL-GPqZoBpZdrNJYH3g'

export const ENV =
  typeof __BUILD_ENVIRONMENT__ !== 'undefined'
    ? __BUILD_ENVIRONMENT__
    : 'development'
export const APP_VERSION =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'development'
export const CLERK_PUBLISHABLE_KEY =
  ENV === 'development' ? clerkConfig.development : clerkConfig.production
// Same-origin in every environment: production serves the built UI and the API
// from the Python server, and in development the Bun dev server proxies /api to
// the backend (see ui/src/index.tsx). Keeping it relative means access from
// another machine works, parallel instances on other ports work, and the API
// port never has to reach browser code — Bun does not inline process.env there.
export const AGENT_URL = '/api'

export const agentUrl = (agentId: AgentId) => `${AGENT_URL}/${agentId}`
export const conversationUrl = (agentId: AgentId, conversationId: string) =>
  `${AGENT_URL}/${agentId}/conversations/${conversationId}`
export const conversationMessagesUrl = (
  agentId: AgentId,
  conversationId: string
) => `${AGENT_URL}/${agentId}/conversations/${conversationId}/messages`

// Display helper - converts lowercase agent ID to title case for UI
export const agentDisplayName = (agentId: AgentId): string =>
  `${agentId.charAt(0).toUpperCase() + agentId.slice(1)}⟡`

export const agentAvatar = (agentId: AgentId): string => {
  switch (agentId) {
    case 'david':
      return davidAvatar
    case 'hanna':
      return hannaAvatar
    default: {
      const _exhaustive: never = agentId
      throw new Error(`Unknown agent: ${String(_exhaustive)}`)
    }
  }
}

// Transparent-cutout portrait shown inside the thinking-state gradient ring.
// Only David has a dedicated cutout; other agents fall back to their avatar.
export const agentThinkingAvatar = (agentId: AgentId): string =>
  agentId === 'david' ? davidThinking : agentAvatar(agentId)
